/**
 * Merkezi API Yapılandırması
 * 
 * Backend bağlantı adresi .env dosyasındaki REACT_APP_API_URL değişkeni ile yönetilir.
 * Değişken tanımlı değilse:
 * - Geliştirme (development) ortamında: http://localhost:5002/api
 * - Canlı (production) ortamında: https://yedkurs.apiasder.online/api
 */

const defaultApiUrl = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5002/api'
  : 'https://yedkurs.apiasder.online/api';

const rawApiUrl = process.env.REACT_APP_API_URL || defaultApiUrl;
const cleanApiUrl = rawApiUrl.trim().replace(/\/+$/, '');

export const API_BASE_URL = cleanApiUrl.endsWith('/api')
  ? cleanApiUrl
  : `${cleanApiUrl}/api`;

// Sunucu kök adresi (/api eki olmadan, statik dosyalar/yüklemeler için)
export const SERVER_BASE_URL = API_BASE_URL.replace(/\/api$/, '');

export default API_BASE_URL;
